import * as Yup from 'yup'

const useValidationSchema = () => {
  return Yup.object().shape({
    promoCode: Yup.string().required(),
  })
}

export default useValidationSchema
